import React from 'react'

import ReactWeather, { useVisualCrossing } from 'react-open-weather'
import { makeStyles } from '@material-ui/core'

const useStyles = label =>
  makeStyles({
    root: {
      maxWidth: '1000px',
      position: 'relative',
      height: '220px',
      minHeight: '220px',
      overflow: 'hidden',
      '& .rw-container': {
        display: 'flex',
        height: '200px',
        margin: '10px 0',
        '& .rw-container-header': {
          display: label ? 'inline' : 'none',
        },
        '& .rw-today-hr': {
          margin: '3px 0',
        },
        '& .rw-today-current': {
          fontSize: 20,
        },
        '& .rw-today-desc': {
          fontSize: 12,
        },
      },
    },
    close: {
      position: 'absolute',
      top: 0,
      right: 0,
      opacity: 0.5,
    },
  })()

const WeatherWidget = ({
  label,
  lat,
  lng,
  className,
  listItem,
  metric = 'metric',
}) => {
  const classes = useStyles(label)

  const { data, isLoading, errorMessage } = useVisualCrossing({
    key: 'J42PQDKC98JVCR8NBH5NPHC5L',
    // key: '5D3KC59YMF8XQD75MCRX34NM8',
    // key: 'ANAAQ5CBKM6G9E93UVHQ85YZB',
    lat: lat || '48.137154',
    lon: lng || '11.576124',
    lang: 'en',
    unit: metric, // values are (metric,us,uk)
  })

  if (!listItem && localStorage.getItem('weatherWidget') === 'hidden') {
    return null
  }

  // const hide = () => {
  //   if (confirm('Hide until cache reset? Refresh page after confirming.')) {
  //     localStorage.setItem('weatherWidget', 'hidden')
  //   }
  // }

  return (
    <div className={className || classes.root}>
      <ReactWeather
        isLoading={isLoading}
        errorMessage={errorMessage}
        data={data}
        lang="en"
        locationLabel={label}
        unitsLabels={
          metric == 'us'
            ? {
                temperature: 'F',
                windSpeed: 'mph',
              }
            : {
                temperature: 'C',
                windSpeed: 'Km/h',
              }
        }
        showForecast
      />
      {/* {!listItem && (
        <div className={classes.close} onClick={hide}>
          X
        </div>
      )} */}
    </div>
  )
}

export default WeatherWidget
